import type { InvoiceType } from '../types';

export type InvoiceTypeMeta = {
  text: string;
  color: string;
};

const INVOICE_TYPE_META_MAP: Record<string, InvoiceTypeMeta> = {
  special: { text: '专票', color: 'blue' },
  vat_special: { text: '专票', color: 'blue' },
  normal: { text: '普票', color: 'default' },
  vat_normal: { text: '普票', color: 'default' },
};

export function normalizeInvoiceType(value?: string | null): InvoiceType {
  const normalized = String(value ?? '').trim().toLowerCase();
  if (normalized === 'special' || normalized === 'vat_special') return 'special';
  if (normalized === 'normal' || normalized === 'vat_normal') return 'normal';
  return 'normal';
}

export function getInvoiceTypeMeta(value?: string | null): InvoiceTypeMeta {
  const normalized = String(value ?? '').trim().toLowerCase();
  if (!normalized) {
    return { text: '-', color: 'default' };
  }
  return INVOICE_TYPE_META_MAP[normalized] ?? { text: String(value), color: 'default' };
}
